<div class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{'Pages.OrderSent.Title' | translate}}</mat-card-title>
        </mat-card-header>
        <img mat-card-image src="/assets/img/order_sent.png" class="small-logo"/>
        <mat-card-content>
            <p>{{'Pages.OrderSent.Message' | translate}}</p>
        </mat-card-content>
          <mat-card-actions>
            <button mat-flat-button color="accent" class="fill-parent-width" (click)="seeOrderHistory()">{{'Pages.OrderSent.MyOrders' | translate}}</button>
            <div style="height:10px;"></div>
            <button mat-flat-button color="accent" (click)="back()" class="fill-parent-width">{{'Pages.OrderSent.Return' | translate}}</button>
          </mat-card-actions>
    </mat-card>
</div>